import errorImg from "../../images/error.png";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { motion } from "framer-motion";
import "./Error.scss";

const containerVariants = {
  // initial state
  hide: {
    opacity: 0,
    y: "100vh",
  },
  //animate state
  show: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.5,
      duration: 0.4,
    },
  },
  exit: {
    opacity: 0,
    y: "-100vh",
    transition: { ease: "easeInOut", duration: 0.3 },
  },
};

const Error = () => {
  return (
    <motion.section
      className="error"
      variants={containerVariants}
      initial="hide"
      animate="show"
      exit="exit"
    >
      <div className="container">
        <div className="error-content">
          <h1 className="error-h1 text-center text-white">Error</h1>
          <div className="row">
            <div className="col-4 mx-auto text-center">
              <img
                src={errorImg}
                alt="error 404"
                className="img-fluid"
              />
              <p className="error-para">Page not found.</p>
              <Link to="/">
                <Button
                  variant="outlined"
                  color="primary"
                  className="error-btn"
                >
                  Back to home.
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Error;
